import React from "react";
import { Modal } from "react-bootstrap";

const ReminderAlertMessage = ({ handleRemainderMessage, remainderMsgShowHide }) => {
  return (
    <Modal
      show={Boolean(remainderMsgShowHide)}
      onHide={handleRemainderMessage}
      size="lg"
      dialogClassName="rt-tools-modal reminder-alert-modal"
      centered
    >
      <style>{`
        /* Ensure modal and backdrop layers are on top */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .reminder-alert-modal.modal-dialog {
          transform: scale(0.95) !important;
          transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .reminder-alert-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .reminder-alert-modal {
          --task-accent: #171717;
          --task-soft: #f5f5f5;
          max-width: 680px !important;
          width: 100% !important;
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
        }

        .reminder-alert-modal .modal-content {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          color: #1e293b !important;
          border-radius: 0 !important;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
        }

        .reminder-alert-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 16px 24px 14px 24px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .reminder-alert-modal .modal-header::before {
          display: none !important;
        }

        .reminder-alert-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 10px !important;
          width: 100% !important;
        }

        .reminder-alert-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: flex-start !important;
          gap: 18px !important;
          width: 100% !important;
        }

        .reminder-alert-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .reminder-alert-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 6px !important;
          min-width: 0 !important;
          padding-top: 2px !important;
        }

        .reminder-alert-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #1e293b !important;
          font-size: 18px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .reminder-alert-modal .rt-header-icon {
          width: 44px !important;
          height: 44px !important;
          min-height: 44px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .reminder-alert-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 10px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .reminder-alert-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
        }

        .reminder-alert-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
        }

        .reminder-alert-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 3px 8px !important;
          height: 24px !important;
          min-height: 24px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: none !important;
          line-height: 1 !important;
        }

        .reminder-alert-modal .rt-meta-chip i {
          font-size: 11.5px !important;
          margin-right: 4px !important;
          color: #0891b2 !important;
        }

        .reminder-alert-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 36px !important;
          height: 36px !important;
          padding: 0 !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
        }

        .reminder-alert-modal .rt-action-btn:hover {
          color: #1e293b !important;
          border-color: #94a3b8 !important;
          background: #f8fafc !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
        }

        .reminder-alert-modal .rt-action-btn:active {
          transform: translateY(0) !important;
        }

        .reminder-alert-modal .rt-action-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
          transition: color 0.2s ease !important;
        }

        .reminder-alert-modal .rt-action-btn:hover i {
          color: #ef4444 !important;
        }

        .reminder-alert-modal .modal-body {
          padding: 24px !important;
          background: #f8fafc !important;
        }

        .reminder-alert-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 14px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
        }

        .reminder-alert-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          padding: 7px 14px !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        .reminder-alert-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #1e293b !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
        }

        .reminder-alert-modal .wf-modal-footer-close-btn:active {
          transform: translateY(0) !important;
        }

        .reminder-alert-modal .wf-modal-footer-close-btn i {
          font-size: 11px !important;
          color: #94a3b8 !important;
        }

        .reminder-alert-modal .wf-modal-footer-close-btn:hover i {
          color: #ef4444 !important;
        }
      `}</style>
      <Modal.Header>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <i className="rt-header-icon fa fa-bell-o" aria-hidden="true" />
              <div className="rt-header-copy">
                <h2 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    <span>Reminder Alert Message</span>
                    <span className="rt-modal-title-badge">Alert</span>
                  </span>
                </h2>
                <div className="rt-modal-meta-row">
                  <span className="rt-meta-chip">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Notification
                  </span>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={handleRemainderMessage}
              title="Close"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          className="p-4 bg-white border"
          style={{
            borderRadius: "0",
            borderColor: "#e2e8f0",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)"
          }}
        >
          <div className="d-flex align-items-start" style={{ gap: "16px" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                minWidth: "42px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f5f5f5",
                border: "1px solid #d4d4d4",
                color: "#171717",
                fontSize: "16px",
                borderRadius: "0"
              }}
            >
              <i className="fa fa-envelope-o" aria-hidden="true" />
            </div>
            <div style={{ flex: 1 }}>
              <h4
                style={{
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#1e293b",
                  margin: "0 0 8px 0"
                }}
              >
                Incomplete Registration
              </h4>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  color: "#475569",
                  lineHeight: "1.6",
                  margin: 0
                }}
              >
                You have registered with us but haven't returned to complete
                your application. Please do so by clicking on the link below:
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="wf-modal-footer-close-btn"
          onClick={handleRemainderMessage}
        >
          <i className="fa fa-times" aria-hidden="true" />
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReminderAlertMessage;
